module.exports = __webpack_public_path__ + "assets/img/staticAnalysis-active.b63e09c0.svg";